
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5f8ee07a\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UnitInput.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UnitInput.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5f8ee07a\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UnitInput.vue"),
  /* scopeId */
  "data-v-5f8ee07a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/components/UnitInput.vue
// module id = 553
// module chunks = 1